import { useIntl } from "react-intl";

const DynamicObjectFields = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.DynamicObjectFields.header",
            defaultMessage: "Dynamic object fields"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.DynamicObjectFields.body",
            defaultMessage:
                "Dynamic and efficient form submission enables requestors and agents to select assets or services directly from request fields in Jira Service Management, giving your agents the context they need to resolve an issue or request quickly."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default DynamicObjectFields;
